import React, { FC } from 'react'
import { StyledContainer, StyledImage, StyledText, SubContainer, ImageContainer } from './styles'
import ArrowRightIcon from '../../../icons/ArrowRightIcon'
import { defaultLoader } from '../../../../../utils/imageLoaders'

type SectionItemProps = {
  name: string
  img: string
  linkToRedirect: string
}

const SectionItemVarTwo: FC<SectionItemProps> = ({ name, img, linkToRedirect }) => (
  <StyledContainer
    onClick={() => {
      window.location.href = linkToRedirect
    }}
  >
    <SubContainer>
      <ImageContainer>
        <StyledImage loader={defaultLoader} width={60} height={60} src={img} alt={name} />
      </ImageContainer>
      <StyledText onClick={(e) => e.preventDefault()} href={linkToRedirect}>
        {name}
      </StyledText>
    </SubContainer>
    <ArrowRightIcon style={{ minWidth: 'fit-content' }} />
  </StyledContainer>
)

export default SectionItemVarTwo
